import React, { FC, Suspense } from 'react';
import { Routes as ReactRouterRoutes, Route } from 'react-router-dom';

import { retryImportChunk } from '@savgroup-front-common/core/helpers/retryImportChunk';
import { AppErrorBoundary } from '@savgroup-front-common/core/molecules/ErrorBoundary';
import { cn } from '@savgroup-front-common/primitive/lib/utils';

import { BASES } from '../../../constants/routing';
import { VideoCallLauncherContextProvider } from '../../components/FileInfoNewUi/VideoCallLauncher/VideoCallLauncher.context';
import { FloatingWindowVideoCall } from '../../components/FileInfoNewUi/FileTabs/VideoCallLauncherTab/FloatingWindowVideoCall/FloatingWindowVideoCall';
import { AppBar } from '../../components/Header/AppBar/AppBar';
import { APP_BOTTOM_BAR_HEIGHT_PADDING_CLASS } from '../../components/Header/AppBar/BottomBar/BottomBar.constants';
import Routes from '../routes/Routes';

import { useMinimalLayout } from './hooks';

const IframeRoutes = React.lazy(() =>
  retryImportChunk(() => import('../routes/IframeRoutes/IframeRoutes')),
);

const Layout: FC = () => {
  const isMinimalLayoutEnabled = useMinimalLayout();

  if (isMinimalLayoutEnabled) {
    return (
      <AppErrorBoundary>
        <main className="h-screen overflow-x-hidden overflow-y-auto bg-surface-base-default">
          <ReactRouterRoutes>
            <Route path={`${BASES.IFRAME}/*`} element={<IframeRoutes />} />
          </ReactRouterRoutes>
        </main>
      </AppErrorBoundary>
    );
  }

  return (
    <AppErrorBoundary>
      <VideoCallLauncherContextProvider>
        <FloatingWindowVideoCall />

        <div className="flex h-screen flex-col">
          <Suspense fallback={<div className="h-12 bg-surface-brand-default" />}>
            <AppBar />
          </Suspense>
          <main
            className={cn(
              'min-h-0 flex-1 overflow-x-hidden overflow-y-auto bg-surface-base-default md:pb-0',
              APP_BOTTOM_BAR_HEIGHT_PADDING_CLASS,
            )}
          >
            <Routes />
          </main>
        </div>
      </VideoCallLauncherContextProvider>
    </AppErrorBoundary>
  );
};

export default React.memo(Layout);
